import { Box, Button, Typography } from "@mui/material"

import ModalBox from "../../ModalBox"
import { BoxModal } from "../styled"
import { CloseButton } from "../../styled"
import { ErrorModalProps } from "./props"

const ErrorModal = ({
  open,
  onClose,
  errorText,
}: ErrorModalProps) => (
  <ModalBox open={open} onClose={onClose}>
    <Box sx={BoxModal}>
      <Typography variant="h3" sx={{ mb: 4 }}>
        {errorText}
      </Typography>
      <Button variant="contained" sx={CloseButton} onClick={onClose}>
        ОК
      </Button>
    </Box>
  </ModalBox>
)

export default ErrorModal
